import { render, staticRenderFns } from "./QuestionInputTinyText.vue?vue&type=template&id=27427739"
import script from "./QuestionInputTinyText.vue?vue&type=script&lang=js"
export * from "./QuestionInputTinyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports